const globalConfig = {
  // baseUrl: http://192.168.3.6:84
  baseUrl:
    process.env.NODE_ENV === "development"
      ? "https://api.zy-ads.com"
      : "https://api.zy-ads.com",
};

export default globalConfig;
